export const computeLineMaterialQuantity = (
  useNesting: boolean | null,
  materialLayoutQuantity: number,
  maxPartsPerLayout: number | null,
  totalQuantity: number,
): number => {
  if (!useNesting) {
    return Math.ceil(materialLayoutQuantity * totalQuantity);
  }

  return Math.ceil(totalQuantity / Math.max(maxPartsPerLayout ?? 1, 1));
};
